import TasksPage from "./TasksPage";

export default TasksPage;
